export default "__VITE_ASSET__418e6af3__"